module.exports = __webpack_public_path__ + "static/media/payment.7559dace.png";